import { Children, type ReactNode } from 'react';

import { applyThresholdDefaults } from './apply-threshold-default.js';
import { isSlot } from '../../../core/utils/is-slot.js';
import { Label } from '../slots/Label.js';
import { Threshold } from '../slots/Threshold.js';
import type { GaugeChartSlotsConfig } from '../types/gauge-chart-config.js';

export const iterateSlots = (children?: ReactNode): GaugeChartSlotsConfig => {
  const slots: GaugeChartSlotsConfig = {
    thresholds: [],
  };
  Children.forEach(children, (child) => {
    if (isSlot(child, Label)) {
      slots.label = child.props.children ?? null;
    } else if (isSlot(child, Threshold)) {
      const threshold = applyThresholdDefaults(child.props);
      slots.thresholds.push(threshold);
    }
  });

  return slots;
};
